import * as React from 'react';

const SvgChevronDownOutlined = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 25"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="M5.077 8.797a.75.75 0 1 0-1.091 1.03l7.14 7.56.042.043a.75.75 0 0 0 1.072-.043l7.14-7.56a.75.75 0 0 0-1.091-1.03l-6.534 6.918a.1.1 0 0 1-.145 0z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgChevronDownOutlined;
